import React from 'react'
import PropTypes from 'prop-types'
import { Instagram } from 'react-bootstrap-icons'
import { Link } from 'react-router-dom'
import { Container } from 'react-bootstrap'

const Help = (props) => {
  return (
    <div className='help'>
        <Container>
            {props.lang === 'en' &&
                    <div className='help-desc'>
                        <h2>In a pinch?</h2>
                        <h3>Call <b><a href="tel:+18737386310">(873) 738-6310</a></b> or message us on <Link to={ 'https://www.instagram.com/hull.sunday.run.day/' }>Instagram</Link></h3>
                    </div>
            }
            {props.lang === 'fr' &&
                    <div className='help-desc'>
                        <h2>Besoin d'aide&nbsp;?</h2>
                        <h3>Appelez le <b><a href="tel:+18737386310">(873) 738-6310</a></b> ou envoyez-nous un message sur <Link to={ 'https://www.instagram.com/hull.sunday.run.day/' }>Instagram</Link></h3>
                    </div>
                    
            }
            <Link to={ 'https://www.instagram.com/hull.sunday.run.day/' }><Instagram size={60} /></Link>
        </Container>
    </div>
  )
}

Help.propTypes = {
    lang: PropTypes.string
}

export default Help